import { HIDE_TYPING_INDICATOR, SHOW_TYPING_INDICATOR } from "../constants";

export const typingIndicator = (state = false, action: any) => {
  switch (action.type) {
    case SHOW_TYPING_INDICATOR:
      return true;
    case HIDE_TYPING_INDICATOR:
      return false;
    default:
      return state;
  }
};
